// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AddReceiptButton: 'add-receipt-button',
	DeleteButton: 'delete-button',
	AddPaymentButton: 'add-payment-button',
	DeleteButton1: 'delete-button-1',
	Container: 'container',
	Container1: 'container-1',
	SelectOrderOfSectionsInDocumentsDropdown:
		'select-order-of-sections-in-documents-dropdown',
	SortIcon: 'sort-icon',
	SortIcon1: 'sort-icon-1',
	Input: 'input',
	Input1: 'input-1',
	Input2: 'input-2',
	Input3: 'input-3',
	SelectedFileTypeRadioGroup: 'selected-file-type-radio-group',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
